import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Auth, user } from '@angular/fire/auth';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FulleBaseclientService {

  urlBaseSlim: string = environment.apiUrlSlim;

  user$: Observable<any>;
  constructor(
    private http: HttpClient,
    private af: AngularFireAuth,
    private auth: Auth
  ) {
    this.user$ = user(this.auth);
  }

  async getBaseSlim(endurl: string, params?: any): Promise<any> {
    const token = await this.getIdToken();
    // console.log("token : ", token)

    return firstValueFrom(
      this.http.get(this.urlBaseSlim + endurl, {
        params,
        headers: {
          "Content-Type": "application/json",
          "Authorization": token
        }
      })
    );
  }

  async headBaseSlim(endurl: string, params?: { merchantId: number }): Promise<boolean> {
    const token = await this.getIdToken();
    // console.log("token : ", token)
    try {
      await firstValueFrom(
        this.http.head(this.urlBaseSlim + endurl, {
          params,
          headers: {
            "Content-Type": "application/json",
            "Authorization": token
          },
          observe: 'response'
        })
      );
      return true;
    } catch (err: any) {
      if (err?.status === 404) return false;
      throw err;
    }
  }

  // Token Firebase client connecté
  private getIdToken(): Promise<string> {
    return new Promise((resolve) => {
      this.af.currentUser.then(function (user: any) {
        if (user) {
          user.getIdToken(false).then(function (idToken: any) {
            resolve(idToken);
          });
        }
        else {
          resolve("invalid_token");
        }
      });
    });
  }
}
